<template>

<com-setting :options="options" :value="value" v-on:change="onChange" />

</template>

<script>

import comSetting from './Setting'

export default {

    props: ['type', 'value', 'logic'],

    components: {
        'com-setting': comSetting
    },

    data: function() {

        return {
            name: {
                exact: 'Exact match',
                within: 'Between low and high ends',
                low: 'Low end',
                high: 'High end'
            },
            numeric: {},
            date: {}
        }

    },
    
    watch: {

        options: function() {

            if (!this.$_.contains(this.options, this.value)) {

                this.$emit('input', this.options[0].value)

            }

        }

    },

    computed: {

        options: function() {

            var options = []

            this.$_.each(this.type.setting.range, function(logic) {

                if (
                    (
                        this.logic !== 'min' 
                        &&
                        this.logic !== 'max'
                    )
                    ||
                    logic !== 'exact'
                ) {

                    options.push({
                        value: logic,
                        text: this[this.type.type][logic] || this.name[logic]
                    })

                }

            }.bind(this))

            return options

        }

    },

    methods: {

        onChange: function(value) {

            this.$emit('input', value)

        }
    
    }

}

</script>

<style scoped>

</style>